export default __webpack_public_path__ + "static/media/G0390.34I-26216_-17367_0.1666262520000.50d14684.jpg";